import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Breadcrumbs,
  Link,
  Divider,
  useMediaQuery
} from "@mui/material";
import { Spin, Typography, Tooltip,Card,Skeleton } from "antd";
import { StarFilled } from "@ant-design/icons";
import ProductSectionNew from "../../components/common/ProductSectionNew";
import BestValueProductSection from "../../components/common/BestValueProductSection";
import TopValuePicksComparison from  "../../components/common/TopValuePicksComparison";
import { UIRecommendationAPIService } from "../../services/api/UIRecommendationAPIService";
import joyLogo from "../../assests/Images/joyLogo.png";
import "./ProductPage.css"; // <-- import new CSS
import ProductListSection from "../../components/common/ProductListSection";
import HomeIcon from "../../assests/Images/home.svg";
import WebIcon from "../../assests/Images/web.svg";
import LogoIcon from "../../assests/Images/kangaroo.webp";
import SearchIcon from "../../assests/Images/list.svg";
import { SidebarNav, MobileBottomNav } from "../../components/common/ChatNavigation.js";
import ProductSkeleton from "../../components/common/ProductSkeleton.js";
import logoIcon from "../../assests/Images/kangaroo.webp"


export default function ProductLinkRender({loadingSkeleton=false,partialData,phone,productId,keyword}) {
  let { phoneNumber, id } = useParams();

  if (!phoneNumber && !id && !loadingSkeleton){
    phoneNumber=phone;
    id=productId;
  }
  // phoneNumber="+913230795798";
  // id="f879c2a016144d78a535b3d51c3e370f";
  // phoneNumber="";
  // id="";
  // loadingSkeleton=true

  // partialData=[
  //   {"asin": null,"image": "https://i5.walmartimages.com/seo/Valhalla-Java-Odinforce-Blend-Strong-Whole-Bean-Coffee-12-oz_e0381642-9489-4690-bc57-d4fd6e1dad53.0bf9af70aa26af70425c00bcdb784441.jpeg","key": "2LD84696JNJL","link": "https://www.walmart.com/ip/Valhalla-Java-Odinforce-Blend-Strong-Whole-Bean-Coffee-12-oz/585856048?classType=REGULAR","price": "14.99","rating": "4.9","reviews": "2684","store": "Walmart","title": "Valhalla Java Odinforce Blend Strong Whole Bean Coffee, 12 oz"},
  //     {"asin":"B007PM9YNA","image": "https://m.media-amazon.com/images/I/71BP8kUMVPL._AC_UL320_.jpg","key": "B007PM9YNA","link": "https://www.amazon.com/Kauai-Whole-Coffee-Estate-Medium/dp/B007PM9YNA/?tag=meetpoppins-20","price": "7.68","rating": "4.4","reviews": "1900","store": "Amazon","title": "Kauai Coffee Koloa Estate Medium Roast - Whole Bean Coffee, 10 oz Package"},
  //     {"asin":"","image": "","key": "","link": "","price": "","rating": "","reviews": "","store": "","title": ""},
  //  ]
  const { Text } = Typography;
   const isDesktop = useMediaQuery("(min-width:768px)"); // same breakpoint as before
    const [activeNav, setActiveNav] = useState(2);

  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [comparisonData,setComparisonData] = useState([]);


  const bottomNavHeight = isDesktop ? 0 : 0;
    const icons = [WebIcon, LogoIcon, SearchIcon];
    const routes = [
      "https://www.shopperoo.us/",
      "/chatbot",
      "/shopping",
    ];

  useEffect(() => {
    if (!phoneNumber && !id) return;
    setLoading(true);
    UIRecommendationAPIService.uiRecommend(phoneNumber, id)
      .then((response) => {
        setProductData(response || {})

        comparisonData.push(response?.top_rated_products?.[0])
        comparisonData.push(response?.lowest_priced_products?.[0])
        comparisonData.push(response?.best_value_products?.[0])

      })
      .catch((err) => console.error("Error fetching product data:", err))
      .finally(() => setLoading(false));
  }, [phoneNumber, id]);

  if (loading) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        px: 2,
      }}
    >
      <Box
        sx={{
          fontSize: 60,
          color: "#ff007f",
          animation: "bounce 1s infinite",
          "@keyframes bounce": {
            "0%, 100%": { transform: "translateY(0)" },
            "50%": { transform: "translateY(-10px)" },
          },
        }}
      >
        <img src={logoIcon} style={{ width: "60px", height: "60px" }} />
      </Box>

      {/* Use a standard div with explicit font styles instead of Typography */}
      <div
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          color: "#333",
          textAlign: "center",
          maxWidth: "400px",
          marginTop: "20px",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
          // Force font rendering
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        }}
      >
        {loadingSkeleton ? "Loading" : "Displaying your results…"}
      </div>
    </Box>
  );
}
  function formatWithOrdinal(num) {
    const suffixes = ["th", "st", "nd", "rd"];
    const v = num % 100;
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
  }

  const date = new Date(productData?._ts * 1000);

  const day = formatWithOrdinal(date.getUTCDate());
  const month = date.toLocaleString("en-GB", { month: "long", timeZone: "UTC" });
  const year = date.getUTCFullYear();

  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");

  const formattedDate = `${day} ${month} ${year}, ${hours}:${minutes} UTC`;


  return (
    <>
     <Box className="wedsiteBreadcrumb">
     <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="https://www.shopperoo.us/">
          Home
        </Link>
        <Typography color="text.primary">Buying Guide</Typography>
        <Typography color="text.primary">{productData?.display_keywords || keyword}</Typography>
      </Breadcrumbs>
       {/* Object Name */}

      </Box>
    <Box sx={{ display: "flex", minHeight: "40vh", bgcolor: "white" }}>


  {!productData && !partialData?
    ( <p style={{ textAlign: "center", marginTop: "4rem" }}>No data available</p>)
    :
  (

    <main
      className="product-link-rendering-section-new"
      style={{
        flex: 1,
        overflowY: "auto", // <-- makes only this scroll
        paddingBottom: !isDesktop ? bottomNavHeight : 0, // leave space for bottom nav
      }}
    >


      <TopValuePicksComparison
        products={productData?.comparison_data}
        bestValueProducts={comparisonData}
        partialData={loadingSkeleton ?partialData:[]}
        keyword={productData?.display_keywords || keyword}
        websiteDisplay={true}
        date={formattedDate}
      />



      <ProductListSection
        bestValueProducts={productData?.best_value_products}
        topRatedProducts={productData?.top_rated_products}
        lowestPricedProducts={productData?.lowest_priced_products}
        loadingSkeleton={loadingSkeleton}
      />

    </main>
  )}
  </Box>
  <Box sx={{ p: 3 ,background:"white"}}>
<Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "24px", }}>
        How Shopperoo Works:
      </Typography>

      <Typography variant="h6" style={{ fontWeight: "bold" }}>
        Real-Time Search
      </Typography>
      <Typography sx={{ mb: 2 }}>
      When You Need It Shopperoo searches on demand when you request a product comparison. We query 8+ major retailers who collectively account for the vast majority of ecommerce dollars spent in the United States. These popular searches are then published to our blog so other shoppers can benefit from the most frequently requested comparisons.
      </Typography>

      <Typography variant="h6" style={{ fontWeight: "bold" }}>
        Our Universe
      </Typography>
      <Typography sx={{ mb: 2 }}>
      We search across major retailers who represent the majority of online shopping activity in the US.
      </Typography>

      <Typography variant="h6" style={{ fontWeight: "bold" }}>
        Best Value Calculation
      </Typography>
      <Typography style={{ marginBottom: 2 }}>
      We calculate the true unit price by dividing the total cost by the number of units (items, ounces, rolls, etc.). This allows fair comparison across different product sizes. For example, a 12-pack at $24 ($2 per unit) vs. a 6-pack at $14 ($2.33 per unit) - the larger pack offers better value even though it costs more upfront. We also consider customer review rating and review counts while finding the best value.
      </Typography>

      <Typography variant="h6" style={{ fontWeight: "bold" }}>
        Rating Methodology
      </Typography>
      <Typography sx={{ mb: 2 }}>
      Our rating system shows a weighted average of customer reviews across all stores carrying the product, with each retailer's ratings weighted equally over time.
      </Typography>

      <Divider style={{marginTop:"24px"}}/>

      {/* Disclaimer */}
      <Typography variant="body2" color="text.secondary">
        <b>Disclaimer:</b> Shopperoo earns affiliate commissions when you purchase through our links. This helps keep
        our service free but does not influence how we rank or display results. Our search algorithm objectively sorts
        by price, value, and ratings – we do not accept payment for placement.{" "}
        <Link href="https://www.shopperoo.us/pages/terms-conditions">See full disclaimer here</Link>
      </Typography>

</Box>
    </>
  );
}